import React, { createContext, useState } from "react";

const GardenContext = createContext();

export const GardenProvider = ({ children }) => {
  const [gardens, setGardens] = useState([]); // List of gardens
  const [selectedGarden, setSelectedGarden] = useState(null); // Garden to edit
  const [isSidebarOpen, setSidebarOpen] = useState(false); // Sidebar visibility

  const addGarden = (garden) => setGardens([...gardens, garden]);
  const updateGarden = (updatedGarden) =>
    setGardens(gardens.map((garden) => (garden.garden_uuid === updatedGarden.garden_uuid ? updatedGarden : garden)));
  const deleteGarden = (gardenUuid) =>
    setGardens(gardens.filter((garden) => garden.garden_uuid !== gardenUuid));

  return (
    <GardenContext.Provider
      value={{
        gardens,
        selectedGarden,
        isSidebarOpen,
        setGardens,
        setSelectedGarden,
        setSidebarOpen,
        addGarden,
        updateGarden,
        deleteGarden,
      }}
    >
      {children}
    </GardenContext.Provider>
  );
};

export default GardenContext;
